var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReilmLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 43,
    viewBox: "0 0 148 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5860_1744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1365 11.4577L25.5936 0L13.9496 2.83051L15.8138 4.79541L0 19.8366L0.0086572 43H6.3313V22.5402L20.1684 9.38017L22.1365 11.4577Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4437 16.7305H17.375V22.7983H23.4437V16.7305Z",
    fill: "#4CBC18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2248 43.0007L34.3992 23.9028V36.7742L26.1431 36.78L19.7743 43.0007H40.7247V21.4964L34.2665 15.0391L7.71484 43.0007H16.2248Z",
    fill: "#4CBC18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.449 43.0016V21.2656H126.477L138.085 37.7237L136.325 37.3264L147.904 21.2656H147.96V43.0016H143.846V30.5446L144.101 32.6728L137.035 42.7179H136.978L129.712 32.6728L130.422 30.7148V43.0016H126.449Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.43 22.1172H109.545V39.0293H119.364V43.0019H105.43V22.1172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0859 22.1172H97.2005V43.0019H93.0859V22.1172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3477 22.1172H85.5942V26.0898H75.4629V30.5449H84.4302V34.5175H75.4629V39.0293H85.9913V43.0019H71.3477V22.1172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3832 22.1172C57.1427 22.1172 58.6279 22.4104 59.8387 22.9968C61.0495 23.5644 61.9671 24.3778 62.5915 25.4372C63.2347 26.4776 63.5563 27.7167 63.5563 29.1544C63.5563 30.0057 63.4239 30.857 63.159 31.7083C62.9131 32.5595 62.4969 33.3352 61.9104 34.0351C61.3428 34.735 60.586 35.3026 59.64 35.7377C58.6941 36.1538 57.5211 36.3619 56.1211 36.3619H53.1696V43.0019H49.0547V22.1172H55.3832ZM56.0927 32.3893C56.9251 32.3893 57.5684 32.219 58.0224 31.8785C58.4954 31.5191 58.8265 31.1029 59.0157 30.63C59.2049 30.1381 59.2995 29.6936 59.2995 29.2963C59.2995 29.0693 59.2617 28.7855 59.186 28.445C59.1292 28.0856 58.9968 27.7262 58.7887 27.3667C58.5806 27.0073 58.2589 26.7046 57.8238 26.4587C57.4076 26.2128 56.84 26.0898 56.1211 26.0898H53.1696V32.3893H56.0927ZM59.9522 34.9431L65.1172 43.0019H60.3211L55.0426 35.0566L59.9522 34.9431Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5860_1744"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 43,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReilmLogo);
export default __webpack_public_path__ + "static/media/reilm-logo.888434b2e3b712a0ea6c041d6bf7f6b2.svg";
export { ForwardRef as ReactComponent };